import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import LatBar from './LatBar'
import NotificationBar from './NotificationBar'
import UpBar from './UpBar'
import userAvatar from '../../../assets/img/User-Avatar.png';
import { Outlet, useNavigate } from 'react-router-dom'
import { AuthProvider } from '../../../context/AuthProvider'
import useIndex from '../../../hooks/useIndex'
import useNotifications from '../../../hooks/useNotifications'

const Dashboard = () => {
    const serverUrl = process.env.REACT_APP_BACK_URL;
    const { auth } = useIndex();
    const navigate = useNavigate();
    const [activeBar, setActiveBar] = useState(false);
    const [activeNot, setActiveNot] = useState(false);
    const [disabledNot, setDisabledNot] = useState(false);
    const [userImage, setUserImage] = useState(auth?.avatar ?? userAvatar);

    // Una sola instancia del hook para que UpBar (badge) y
    // NotificationBar (feed) compartan estado y polling.
    const notifications = useNotifications();

    useEffect(() => {
        setUserImage(serverUrl + auth?.avatar);
    }, [auth]);

    // Si el jugador llegó al login porque tenía un QR de entrega de
    // jugadas pendiente (lo guardamos en localStorage al entrar a
    // /claim-moves/:token sin sesión), al aterrizar en el dashboard lo
    // mandamos directo al claim para que se procese automáticamente.
    useEffect(() => {
        if (!auth?.id) return;
        try {
            const pending = localStorage.getItem('pending_claim_token');
            if (pending) {
                localStorage.removeItem('pending_claim_token');
                navigate(`/claim-moves/${pending}`, { replace: true });
            }
        } catch { /* noop */ }
    }, [auth?.id, navigate]);

    useEffect(() => {
        if (!activeNot) {
            setTimeout(() => {
                setDisabledNot(false);
            }, 500);
        } else {
            setDisabledNot(true);
        }
    }, [activeNot]);

    useEffect(() => {
        if (disabledNot) {
            document.addEventListener('click', function (event) {
                if (!(event.target.id !== 'contNotif' && event.target.id !== 'barNot')) {
                    setActiveNot(false);
                }
            });
        }
    }, [disabledNot]);

    return (
        <AuthProvider>


            <Box display={'flex'}>
                <NotifBarContainer id="contNotif" className={disabledNot && 'active'}>
                    <NotificationBar
                        activeNot={activeNot}
                        setActiveNot={setActiveNot}
                        notifications={notifications}
                    />
                </NotifBarContainer>
                <Box id="contLat">
                    <LatBar
                        activeBar={activeBar}
                        setActiveBar={setActiveBar}
                        userAvatar={userImage}
                    />
                </Box>
                <Box
                    flex={'1'}
                    display={'flex'}
                    flexDirection={'column'}
                    overflow={'hidden'}
                >
                    <UpBar
                        activeBar={activeBar}
                        setActiveBar={setActiveBar}
                        activeNot={activeNot}
                        setActiveNot={setActiveNot}
                        userAvatar={userImage}
                        notifications={notifications}
                    />
                    <ContentDash flex={'1'}>
                        <Outlet />
                    </ContentDash>
                </Box>
            </Box>
        </AuthProvider>
    )
}

export default Dashboard

const NotifBarContainer = styled.div`
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,.5);
    z-index: 100;

    display: none;
    &.active {
        display: block;
    }
`

const ContentDash = styled.div`
    width: 100%;
    height: calc(100vh - 52px);
    overflow-x: hidden;
    overflow-y: scroll;
    position: relative;
    background: #F5F5F5;

    @media (max-width: 768px) {
        height: calc(100vh - 48px);
    }

    @media (max-width: 420px) {
        height: calc(100vh - 44px);
    }
`